<div class="start-day-switcher-container-round">
  <button
    class="round-switch-btn"
    [class.is-start]="dayStart"
    [class.is-end]="!dayStart"
    [class.is-loading]="isLoading"
    (click)="dayStart ? onStartDay() : onEndDay()"
    [disabled]="isLoading"
    [attr.aria-label]="actionLabelKey | translate"
  >
    <span class="b-ambient" [class.stop]="!dayStart" aria-hidden="true"></span>
    <span class="b-orb b-orb1" [class.stop]="!dayStart" aria-hidden="true"></span>
    <span class="b-orb b-orb2" [class.stop]="!dayStart" aria-hidden="true"></span>
    <span class="b-arc" [class.stop]="!dayStart" aria-hidden="true"></span>
    <span class="b-rip p1" [class.run]="!dayStart" [class.sc]="!dayStart" aria-hidden="true"></span>
    <span class="b-rip p2" [class.run]="!dayStart" [class.sc]="!dayStart" aria-hidden="true"></span>

    <span class="b-conic" [class.stop]="!dayStart" aria-hidden="true"></span>
    <span class="b-sep" aria-hidden="true"></span>
    <span class="core b-face" [class.stop]="!dayStart">
      <span class="icon icon-power" *ngIf="dayStart" aria-hidden="true"></span>
      <span class="icon icon-stop" *ngIf="!dayStart" aria-hidden="true"></span>
      <span class="label">{{ actionLabelKey | translate }}</span>
    </span>
  </button>
</div>


